import { render } from "./DocumentVersionView.vue?vue&type=template&id=6f5b2cfc"
import script from "./DocumentVersionView.vue?vue&type=script&lang=js"
export * from "./DocumentVersionView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__